var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 py-1 flex flex-row"},[_c('span',{staticClass:"font-light"},[_vm._v(_vm._s(_vm.item.location))]),_c('span',{staticClass:"ml-2 font-medium"},[_vm._v(_vm._s(_vm.item.destination))])])}
var staticRenderFns = []

export { render, staticRenderFns }